import React from "react";
import { Card, CardImg, CardText, CardBody, CardTitle, CardSubtitle } from "reactstrap";
import { Loading } from "./LoadingComponent";
import { FadeTransform } from "react-animation-components"

function RenderCard({item, isLoading, errMess, imgsrc}){
    if(isLoading){
        return(
            <Loading/>
        )
    }
    else if(errMess){
        return(
            <h4>{errMess}</h4>
        )
    }
    else{
        return(
            <FadeTransform in
                transformProps={{
                    exitTransform: 'scale(0.5) translateY(-50%)'
                }}>
            <Card>
                <CardImg src={imgsrc} alt={item.name}></CardImg>
                <CardBody>
                    <CardTitle>{item.name}</CardTitle>
                    {item.designation ? <CardSubtitle>{item.designation}</CardSubtitle> : null}
                    <CardText>{item.description}</CardText>
                </CardBody>
            </Card>
            </FadeTransform>
        )
    }
}

export default function Home(props){
    return(
        <div className="container"> 
            <div className="row align-items-start">
                <div className="col-12 col-md m-1">
                    <RenderCard item={props.dish} isLoading={props.dishesLoading} errMess={props.dishErrMess} imgsrc="assets/images/uthappizza.png"></RenderCard>
                </div>
                <div className="col-12 col-md m-1">
                    <RenderCard item={props.promotion} isLoading={props.promoLoading} errMess={props.promoErrMess} imgsrc="assets/images/buffet.png"></RenderCard>
                </div>
                <div className="col-12 col-md m-1">
                    <RenderCard item={props.leader} isLoading={props.leaderLoading} errMess={props.leaderErrMess} imgsrc="assets/images/alberto.png"></RenderCard>
                </div>
            </div>
        </div>
    )
}